import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { EventComponent } from "./event/event.component";
import { AdminSchoolComponent } from "./admin-school/admin-school.component";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule } from "@angular/forms";
import { LoadingComponent } from "../loading/loading.component";
import { NumberDirective } from "./numbers-only.directive";
import { AdminRoutingModule } from "./admin-routing.module";
import { AdminComponent } from "./admin/admin.component";
import { TestComponent } from "./test/test.component";
import { AdminDashboardComponent } from "./admin-dashboard/admin-dashboard.component";
import { ManageBlogsComponent } from "./manage-blogs/manage-blogs.component";
import { ManageCategoriesComponent } from "./manage-categories/manage-categories.component";
import { ManagePagesComponent } from "./manage-pages/manage-pages.component";
import { BlogFormComponent } from "./blog-form/blog-form.component";
import { GameComponent } from "./game/game.component";
import { SubGameComponent } from "./subgame/subgame.component";
import { StudentComponent } from "./student/student.component";
import { UpcomingEventComponent } from "./upcoming-event/upcoming-event.component";
import { PaymentComponent } from "./payment/payment.component";
import { ReportComponent } from "./report/report.component";
import { MeritComponent } from "./merit/merit.component";
import { SumPipeModule } from "./pipe/sum.pipe";
import { TextTransformPipeModule } from "./pipe/format-string";
import { AutoCompleteModule } from "primeng/autocomplete";
import { MapGameComponent } from "./map-game/map-game.component";
import { StudentAttendanceComponent } from "./student-attendance/student-attendance.component";
import { CoachDataComponent } from "./coach-data/coach-data.component";
import { WebDataComponent } from "./web-data/web-data.component";
import { EmailValidatorDirective } from "./email-validator.directive";
import { PaymentInvoice } from "./admin-payment/payment-invoice/payment-invoice.component";
import { PrimengModule } from "../primeng-module";
import { AdminPayment } from "./admin-payment/admin-payment.component";
import { DownloadInvoice } from "./admin-payment/download-invoice/download-invoice.component";
import { ManageEventReport } from "./mange-event-report/manage-event-report.component";
import { DownloadReceipt } from "./admin-payment/download-receipt/download-receipt.component";
import { ManageTeamReport } from "./manage-team-report/manage-team-report.component";
import { UserManagementComponent } from "./user-management/user-management.component";
// New admin feature screens (content, news, medal tally, attendance, playzone, media vault, subscribers)
import { ContentAdminComponent } from "./content-admin/content-admin.component";
import { MailSettingsComponent } from "./mail-settings/mail-settings.component";
import { SiteNoticeComponent } from "./site-notice/site-notice.component";
import { NewsAdminComponent } from "./news-admin/news-admin.component";
import { MedalTallyAdminComponent } from "./medal-tally-admin/medal-tally-admin.component";
import { AffiliationAdminComponent } from "./affiliation-admin/affiliation-admin.component";
import { AttendanceAdminComponent } from "./attendance-admin/attendance-admin.component";
import { PlayzoneAdminComponent } from "./playzone-admin/playzone-admin.component";
import { MediaVaultAdminComponent } from "./media-vault-admin/media-vault-admin.component";
import { SubscribersAdminComponent } from "./subscribers-admin/subscribers-admin.component";
import { PaymentsAdminComponent } from "./payments-admin/payments-admin.component";
import { CertificateContentComponent } from "../certificate-content/certificate-content.component";
import { ConfigureSgfiPaymentComponent } from "./admin-payment/configure-sgfi-payment/configure-sgfi-payment.component";
import { ChangePassComponent } from "../change-pass/change-pass.component";
import { SgfiEntriesComponent } from "./sgfi-entries/sgfi-entries.component";
import { ConfigureIfsSchoolPaymentComponent } from "./admin-payment/configure-ifs-school-payment/configure-ifs-school-payment.component";
import { IfsSchoolDataComponent } from "./ifs-school-data/ifs-school-data.component";
import { ManageEvent } from "./mange-event/manage-event.component";
import { IndianCurrencyPipeModule } from "./pipe/indian-currency.pipe";
import { ViewStudentComponent } from "./student-profile/view-student/view-student.component";
import { SearchStudentProfileComponent } from "./student-profile/search-student-profile/search-student-profile.component";
import { ManualPaymentComponent } from "./student-profile/manual-paymnet/manual-paymnet.component";
import { AdminStudentEnrollmentComponent } from "./student-profile/admin-student-enrollment/admin-student-enrollment.component";
import { AdminStudentProfileEnrollmentComponent } from "./student-profile/admin-student-profile-enrollment/admin-student-profile-enrollment.component";
import { AuthImgModule } from "./auth-img.module";
import { TransfersComponent } from "./transfers/transfers.component";
import { RolesComponent } from "./roles/roles.component";
import { SgfiEventsComponent } from "./sgfi-events/sgfi-events.component";
import { PaymentSettingsComponent } from "./payment-settings/payment-settings.component";
import { NoAccessComponent } from "./no-access/no-access.component";

@NgModule({
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    PrimengModule,
    ReactiveFormsModule,
    AdminRoutingModule,
    SumPipeModule,
    IndianCurrencyPipeModule,
    TextTransformPipeModule,
    FormsModule,
    AutoCompleteModule,
    AuthImgModule,
  ],
  declarations: [
    TransfersComponent,
    RolesComponent,
    SgfiEventsComponent,
    PaymentSettingsComponent,
    NoAccessComponent,
    AdminComponent,
    TestComponent,
    AdminDashboardComponent,
    ManageBlogsComponent,
    ManageCategoriesComponent,
    ManagePagesComponent,
    BlogFormComponent,
    EventComponent,
    GameComponent,
    SubGameComponent,
    AdminSchoolComponent,
    StudentComponent,
    UpcomingEventComponent,
    ManageEventReport,
    ManageEvent,
    ManageTeamReport,
    LoadingComponent,
    PaymentComponent,
    ReportComponent,
    MeritComponent,
    NumberDirective,
    EmailValidatorDirective,
    MapGameComponent,
    StudentAttendanceComponent,
    PaymentInvoice,
    DownloadReceipt,
    DownloadInvoice,
    CoachDataComponent,
    WebDataComponent,
    UserManagementComponent,
    AdminPayment,
    CertificateContentComponent,
    ConfigureSgfiPaymentComponent,
    ConfigureIfsSchoolPaymentComponent,
    ChangePassComponent,
    SgfiEntriesComponent,
    IfsSchoolDataComponent,
    ViewStudentComponent,
    SearchStudentProfileComponent,
    ManualPaymentComponent,
    AdminStudentEnrollmentComponent,
    AdminStudentProfileEnrollmentComponent,
    ContentAdminComponent,
    MailSettingsComponent,
    SiteNoticeComponent,
    NewsAdminComponent,
    MedalTallyAdminComponent,
    AffiliationAdminComponent,
    AttendanceAdminComponent,
    PlayzoneAdminComponent,
    MediaVaultAdminComponent,
    SubscribersAdminComponent,
    PaymentsAdminComponent,
  ],
  providers: [
    SumPipeModule,
    IndianCurrencyPipeModule,
    DatePipe,
    TextTransformPipeModule,
    AutoCompleteModule,
  ],
})
export class AdminModule {}
